import React, { Component } from 'react'
import moment from 'moment'
import { injectIntl } from 'react-intl'

import { Layout, Content, Container, PageTitle } from 'src/components/Layout'
import { Box } from '@chakra-ui/react'
import { Loader } from 'src/components/Loader'
import { geoLocationExists } from 'src/utils/helpers'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'

import WeatherOfflineForm from './WeatherOfflineForm'

import styles from './styles.module.less'
import intlMessages from './translations'
import intlMessagesClaim from '../translations'

class Weather extends Component {
  state = {
    weather: null,
    name: '',
    description: '',
    temperature: 0,
    isOffline: false,
  }

  componentDidMount() {
    if (geoLocationExists() && this.dateExpired(this.props.savedDate)) {
      this.getLocation()
    }

    if (geoLocationExists() && !this.props.isOffline.online) {
      this.setState({
        isOffline: true,
      })
    }
  }

  onSubmit = weather => {
    this.props.setWeatherDescription(weather.description)
  }

  dateExpired = savedDate => {
    if (!savedDate) {
      return true
    }
    const currentTime = moment()
    return currentTime.diff(savedDate, 'h') > 24
  }

  getLocation = () => {
    navigator.geolocation.getCurrentPosition(
      position => {
        this.props.getWeather({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        })
      },
      () => {
        this.setState({
          isOffline: true,
        })
      },
    )
  }

  renderContent = () => {
    if (this.props.loading || !this.props.weather) {
      return <Loader styleVariation='staticWithHeight' />
    }

    const { temperature, description, name } = this.props.weather

    return (
      <Container padder className={`${styles.weatherContainer}`}>
        <h2>{name}</h2>
        <Box my={5}>
          <FontAwesomeIconComponent icon={['far', 'sun-bright']} size='xlg' />
        </Box>
        {/* <WeatherIcon display-if={weatherId} id={weatherId} size="12x" /> */}
        <h2 className={styles.weatherDegree}>{temperature}&#176;C</h2>
        <h2 className={styles.weatherDsc}>{description}</h2>
      </Container>
    )
  }

  render() {
    const { loading, intl, weather } = this.props
    const { isOffline } = this.state

    return (
      <Layout className='m-claims-weather'>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.weatherHeadline)}
            subtitle={intl.formatMessage(intlMessagesClaim.claimsFillOutTheForm)}
          />
          <WeatherOfflineForm
            weatherDescription={this.props.description}
            onSubmit={this.onSubmit}
            display-if={isOffline && !loading}
            history={this.props.history}
          />
          {!isOffline && this.renderContent(weather)}
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(Weather)
